/* tslint:disable */
/* eslint-disable */
/**
 * Quotes Management API
 * API for managing quotes
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface CustomContractVariableValueDto
 */
export interface CustomContractVariableValueDto {
    /**
     * Unique identifier of the variable value
     * @type {string}
     * @memberof CustomContractVariableValueDto
     */
    idVariableValue: string;
    /**
     * The variable value
     * @type {number}
     * @memberof CustomContractVariableValueDto
     */
    value: number;
}

/**
 * Check if a given object implements the CustomContractVariableValueDto interface.
 */
export function instanceOfCustomContractVariableValueDto(value: object): value is CustomContractVariableValueDto {
    if (!('idVariableValue' in value) || value['idVariableValue'] === undefined) return false;
    if (!('value' in value) || value['value'] === undefined) return false;
    return true;
}

export function CustomContractVariableValueDtoFromJSON(json: any): CustomContractVariableValueDto {
    return CustomContractVariableValueDtoFromJSONTyped(json, false);
}

export function CustomContractVariableValueDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): CustomContractVariableValueDto {
    if (json == null) {
        return json;
    }
    return {
        
        'idVariableValue': json['idVariableValue'],
        'value': json['value'],
    };
}

export function CustomContractVariableValueDtoToJSON(json: any): CustomContractVariableValueDto {
    return CustomContractVariableValueDtoToJSONTyped(json, false);
}

export function CustomContractVariableValueDtoToJSONTyped(value?: CustomContractVariableValueDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'idVariableValue': value['idVariableValue'],
        'value': value['value'],
    };
}

